// Shared ad placement inventory — used by both the public ad renderer and the Admin CMS.
export const AD_PLACEMENTS = [
  { id: "home-top", label: "Homepage Hero", ratioLabel: "2:1", ratio: 2 / 1, size: "1024×500", aspect: "2 / 1", fit: "contain" },
  { id: "home-mid", label: "Homepage Mid Banner", ratioLabel: "1.91:1", ratio: 1.91, size: "1200×628", aspect: "1.91 / 1", fit: "cover" },
  { id: "sidebar", label: "Sidebar Square", ratioLabel: "1:1", ratio: 1, size: "300×300", aspect: "1 / 1", fit: "cover" },
  { id: "feed-square", label: "In-feed Square", ratioLabel: "1:1", ratio: 1, size: "300×300", aspect: "1 / 1", fit: "cover" },
  { id: "mobile-feature", label: "Mobile Featured", ratioLabel: "4:5", ratio: 4 / 5, size: "960×1200", aspect: "4 / 5", fit: "cover" },
];

export const PLACEMENT_MAP = Object.fromEntries(AD_PLACEMENTS.map((p) => [p.id, p]));

// Tolerance for aspect-ratio validation on upload (±12%).
export const RATIO_TOLERANCE = 0.12;
